<template>
  <div>
    <v-btn class="ma-2" text @click.native.stop.prevent="toggleModal" persistent>
      Delete
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px">
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Delete Payment Method</v-toolbar-title>
      </v-toolbar>
      <v-card tile class="modal-content-container">
        <v-card-title>
          <span class="body-heading-small ma-8">Are you sure you want to delete this payment method?</span>
        </v-card-title>
        <v-card-text>
          <v-row class="px-3 justify-space-between">
            <v-btn color="secondary" class="modal-btn" @click="deletePaymentMethod">Delete</v-btn>
            <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Close</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "DeletePaymentMethodModal",

    data() {
      return {
        isModalOpen: false,
      };
    },

    props: {
      paymentMethodId: {
        required: true,
      },
    },

    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      deletePaymentMethod() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .delete(`/cards/${this.paymentMethodId}`)
          .then((response) => {
            this.$store.commit("removePaymentMethod", response.data.payment_method.id);
            this.toggleModal();
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: this.$formatter.getErrorMsg(error),
              type: "error",
            });
            this.toggleModal();
            this.$store.commit("setLoadingStatus", false);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Payment/DeletePaymentMethodModal.vue